// Coconeuses Bio Translations
const coconeusesTranslations = {
  // Page titles
  pageTitle: {
    fr: "Les Coconeuses",
    en: "The Coconeuses"
  },
  
  // Back button
  backButton: {
    fr: "Retour",
    en: "Back"
  },

  // Placeholder text for upcoming bios
  bioPlaceholder: {
    fr: "Biographie à venir...",
    en: "Biography coming soon..."
  },

  // Individual Coconeuses
  coconeuses: {
    jeinar: {
      name: "Jeinar",
      title: {
        fr: "Guide spirituelle & fondatrice de COCON",
        en: "Sacred Guide & Founder of COCON"
      },
      role: {
        fr: "Fondatrice & Gardienne",
        en: "Founder & Guardian"
      },
      expertise: {
        fr: ["Soins énergétiques", "Guidance oracles", "Canalisation", "Holding space"],
        en: ["Energetic healing", "Oracle guidance", "Channeling", "Holding space"]
      },
      quote: {
        fr: "Tenir l'espace pour que le sacré puisse se révéler.",
        en: "Holding space for the sacred to reveal itself."
      },
      bio: {
        fr: `COCON est né du propre chemin de Jeinar.

Un chemin traversé par le silence,
la rupture,
et le courage de recommencer autrement.

Née en Colombie et adoptée en Suisse,
sa vie a été marquée par une profonde transformation intérieure.

Après de nombreuses années à vivre une existence construite sur la performance et les apparences,
une rupture personnelle profonde l'a conduite vers le silence,
l'introspection
et un éveil spirituel.

De ce passage n'est pas née une méthode,
mais une manière d'être.

Aujourd'hui, Jeinar crée des espaces de présence
où chacun peut ralentir,
s'adoucir
et se reconnecter à sa propre vérité intérieure.

Son travail tisse guérison énergétique intuitive,
guidance par les oracles,
messages canalisés
et pratiques incarnées.

Plutôt que de guider d'en haut,
elle marche à tes côtés.

À travers retraites, cérémonies et cercles intimes,
elle ouvre des espaces où l'intuition s'éveille,
le corps se relâche
et la clarté émerge naturellement.

Sa présence est reconnue pour sa profondeur,
sa douceur
et son humour discret.

Elle appelle cela simplement :

tenir l'espace
pour que le sacré
puisse se révéler.`,
        en: `COCON was born from Jeinar's own journey.

A journey shaped by silence,
rupture,
and the courageous decision to begin again.

Born in Colombia and adopted in Switzerland,
her life has been marked by a profound inner transformation.

After many years living a life built on performance and appearances,
a deep personal rupture led her into silence,
introspection
and spiritual awakening.

What emerged from that passage was not a method,
but a way of being.

Today, Jeinar creates spaces of presence
where people can slow down,
soften,
and reconnect with their inner truth.

Her work weaves intuitive energetic healing,
oracle guidance,
channeled messages
and embodied practices.

Rather than guiding from above,
she walks beside.

Through retreats, ceremonies and intimate circles,
she opens spaces where intuition awakens,
the body softens
and clarity naturally emerges.

Her presence is known for its depth,
gentleness
and quiet humor.

She calls it simply:

holding space
for the sacred
to reveal itself.`
      },
      pdfButton: {
        fr: "Découvrir l'histoire de Jeinar",
        en: "Discover Jeinar's story"
      },
      storyPageUrl: "/story/jeinar",
      galleryTitle: {
        fr: "Quelques instantanés avec Jeinar",
        en: "Moments with Jeinar"
      },
      gallery: [
        "https://customer-assets.emergentagent.com/job_c4b2413e-fbb2-49c4-b5be-8ac09232191c/artifacts/xmry8fbp_DSC04671%20%281%29.jpg",
        "https://customer-assets.emergentagent.com/job_c4b2413e-fbb2-49c4-b5be-8ac09232191c/artifacts/fmazpr75_DSC02081.jpg",
        "https://customer-assets.emergentagent.com/job_c4b2413e-fbb2-49c4-b5be-8ac09232191c/artifacts/ha0ikbkz_Copy%20of%20DSC02018.jpg"
      ],
      photo: "https://customer-assets.emergentagent.com/job_c4b2413e-fbb2-49c4-b5be-8ac09232191c/artifacts/yvpyc3ol_DSC04604%20%281%29.jpg"
    },
    stephanie: {
      name: "Stéphanie",
      heroPosition: "center 65%",
      title: {
        fr: "Kinésithérapeute, ostéopathe & Chi Nei Tsang",
        en: "Physiotherapist, Osteopath & Chi Nei Tsang Practitioner"
      },
      role: {
        fr: "Le cercle",
        en: "The Circle"
      },
      expertise: {
        fr: ["Kinésithérapie", "Ostéopathie", "Chi Nei Tsang", "Micronutrition"],
        en: ["Physiotherapy", "Osteopathy", "Chi Nei Tsang", "Micronutrition"]
      },
      quote: {
        fr: "",
        en: ""
      },
      bio: {
        fr: "Bonjour, je suis Stéphanie.\n\nDepuis toujours, mes mains écoutent, ressentent et relient.\n\nKinésithérapeute, ostéopathe, praticienne en Chi Nei Tsang et en micronutrition,\nj'accompagne chaque être vers un mieux-être global, respectueux du rythme du corps et de sa mémoire.\n\nJ'aime ce chemin du soin qui relie le physique, l'émotionnel, l'énergétique et l'alimentaire…\net j'honore la douceur comme voie de transformation.\n\nSi tu as envie de sentir davantage qui je suis,\nje t'invite à découvrir mon univers ici.",
        en: "Hello, I am Stéphanie.\n\nSince always, my hands listen, sense and connect.\n\nAs a physiotherapist, osteopath, practitioner in Chi Nei Tsang and micronutrition,\nI accompany each person toward a deeper state of wellbeing,\nrespecting the rhythm of the body and the memory it carries.\n\nI love this path of care that connects the physical, the emotional, the energetic and the nutritional dimensions…\nand I honour gentleness as a path of transformation.\n\nIf you feel curious to sense more of who I am,\nI invite you to discover my universe here."
      },
      pdfButton: {
        fr: "Lire ma bio complète (PDF)",
        en: "Read the full biography (PDF)"
      },
      pdfUrl: "https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/9tmmtplt_Bio%20Ste%CC%81phanie.pdf",
      galleryTitle: {
        fr: "Quelques instantanés avec Stéphanie",
        en: "Moments with Stéphanie"
      },
      gallery: [
        { url: "https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/gx7uxefi_WhatsApp%20Image%202026-02-08%20at%2017.22.13%20%281%29.jpeg", objectPosition: "center 55%" },
        { url: "https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/11s76nrp_WhatsApp%20Image%202026-02-08%20at%2017.22.13.jpeg", objectPosition: "center 50%" },
        "https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/n3cjvc34_WhatsApp%20Image%202026-02-08%20at%2017.22.21.jpeg"
      ],
      photo: "https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/v301k76m_WhatsApp%20Image%202026-02-08%20at%2017.22.12.jpeg"
    },
    valerie: {
      name: "Valérie",
      title: {
        fr: "Yoga sensible & vibrant",
        en: "Sensitive & Vibrant Yoga"
      },
      role: {
        fr: "Le cercle",
        en: "The Circle"
      },
      expertise: {
        fr: ["Yoga", "Pratiques douces", "Connexion au corps"],
        en: ["Yoga", "Gentle practices", "Body connection"]
      },
      quote: {
        fr: "",
        en: ""
      },
      bio: {
        fr: "Je suis Valérie.\n\nDepuis plus de vingt ans, le yoga m'accompagne\net m'enseigne à écouter, respecter et aimer\nle corps dans toutes ses dimensions.\n\nJ'aime guider des pratiques douces, vivantes et profondes,\noù chacun peut se reconnecter à soi,\nlibérer les tensions\net retrouver de l'espace.\n\nMon approche est intuitive, ancrée, évolutive —\nnourrie de ce que je vis et de ce que je sens.\n\nÀ Bali comme ailleurs, je vous propose un yoga sensible,\nadapté, et surtout… vibrant.",
        en: "I am Valérie.\n\nFor more than twenty years, yoga has been accompanying me,\nteaching me to listen to, respect and love\nthe body in all its dimensions.\n\nI love guiding gentle, living and profound practices\nwhere each person can reconnect with themselves,\nrelease tensions\nand rediscover space within.\n\nMy approach is intuitive, grounded and evolving —\nnourished by what I live and what I feel.\n\nIn Bali and elsewhere, I offer a yoga that is sensitive,\nadapted, and above all… vibrant."
      },
      pdfButton: {
        fr: "Ouvrir la bio complète en PDF",
        en: "Open the full biography (PDF)"
      },
      pdfUrl: "https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/kk06ofth_Bio%20Vale%CC%81rie%202026.pdf",
      galleryTitle: {
        fr: "Quelques instantanés avec Valérie",
        en: "Moments with Valérie"
      },
      gallery: [
        "https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/7ofw1m7u_WhatsApp%20Image%202026-02-01%20at%2018.53.39%20%281%29.jpeg",
        { url: "https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/9kig93sk_WhatsApp%20Image%202026-02-01%20at%2018.53.39%20%282%29.jpeg", objectPosition: "center 12%" },
        { url: "https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/yclc5c4m_WhatsApp%20Image%202026-02-01%20at%2018.53.39.jpeg", objectPosition: "center 0%" }
      ],
      photo: "https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/as2yuj7o_WhatsApp%20Image%202026-02-01%20at%2018.53.40.jpeg"
    },
    vanessa: {
      name: "Vanessa",
      title: {
        fr: "Artiste, coach spirituelle & lectures akashiques",
        en: "Eco-conscious Artist, Spiritual Coach & Akashic Records"
      },
      role: {
        fr: "Le cercle",
        en: "The Circle"
      },
      expertise: {
        fr: ["Archives Akashiques", "Coaching spirituel", "Art", "Conscience énergétique"],
        en: ["Akashic Records", "Spiritual coaching", "Art", "Energetic awareness"]
      },
      quote: {
        fr: "",
        en: ""
      },
      bio: {
        fr: "Vanessa Albury est une artiste engagée, coach spirituelle et conférencière internationale dont le travail explore le lien entre créativité, conscience spirituelle et relation vivante avec la nature.\n\nOriginaire du sud des États-Unis et installée à New York depuis 2006, elle a consacré de nombreuses années à l'exploration de pratiques spirituelles et énergétiques tout en poursuivant son chemin artistique.\n\nSon approche relie un travail intérieur profond à une intégration concrète dans la vie quotidienne. À travers l'écoute intuitive, la conscience énergétique et le dialogue réfléchi, elle accompagne chacun à se reconnecter à sa guidance intérieure et à vivre avec plus de cohérence et de clarté.\n\nVanessa propose des lectures des Archives Akashiques et un accompagnement qui associent perception intuitive et intégration concrète. Sa manière de travailler est attentive, intuitive et souvent teintée d'humour, invitant chacun à explorer des questions liées à la direction de vie, aux relations, à la créativité et à l'évolution personnelle.\n\nPendant la retraite, Vanessa apporte au cercle une présence calme et attentive. Son approche invite les participantes à ralentir, à écouter plus profondément et à ouvrir un espace de clarté, d'alignement et d'inspiration renouvelée.",
        en: "Vanessa Albury is an eco-conscious artist, spiritual coach and international speaker whose work explores the connection between creativity, spiritual awareness and our relationship with the natural world.\n\nOriginally from the American South and based in New York City since 2006, she has spent many years exploring spiritual practices and energetic awareness while continuing to develop her artistic path.\n\nHer work bridges deep inner alignment with grounded integration in everyday life. Through intuitive listening, energetic awareness and reflective dialogue, she supports people in reconnecting with their inner guidance and living in greater coherence with their values and aspirations.\n\nVanessa offers Akashic Records readings and coaching that combine intuitive perception with practical integration. Her approach is thoughtful, intuitive and often infused with humour, inviting people to explore questions related to life direction, relationships, creativity and personal evolution.\n\nDuring the retreat, Vanessa brings a calm and attentive presence to the circle. Her way of working encourages participants to slow down, listen more deeply and open space for clarity, alignment and renewed inspiration."
      },
      pdfButton: null,
      pdfUrl: null,
      galleryTitle: {
        fr: "Quelques instantanés avec Vanessa",
        en: "Moments with Vanessa"
      },
      gallery: [
        { url: "https://customer-assets.emergentagent.com/job_c4b2413e-fbb2-49c4-b5be-8ac09232191c/artifacts/3o2jnao6_WhatsApp%20Image%202026-03-05%20at%2008.10.34%20%286%29.jpeg", objectPosition: "center 25%" },
        { url: "https://customer-assets.emergentagent.com/job_c4b2413e-fbb2-49c4-b5be-8ac09232191c/artifacts/jalp1lpf_WhatsApp%20Image%202026-03-05%20at%2008.10.34%20%285%29.jpeg", objectPosition: "center 7%" },
        { url: "https://customer-assets.emergentagent.com/job_c4b2413e-fbb2-49c4-b5be-8ac09232191c/artifacts/vuqnsz3w_WhatsApp%20Image%202026-03-05%20at%2008.10.34%20%284%29.jpeg" }
      ],
      photo: "https://customer-assets.emergentagent.com/job_c4b2413e-fbb2-49c4-b5be-8ac09232191c/artifacts/ac94ule4_WhatsApp%20Image%202026-03-05%20at%2008.10.34%20%287%29.jpeg"
    }
  }
};

export default coconeusesTranslations;
